import { useReactToPrint } from 'react-to-print';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import dayjs from 'dayjs';
import { useImmutableCallback } from '@agro1desenvolvimento/react-hooks';
import { StepComponent } from '../types';
import Yup from '../../../../utils/yup';
import SementesList from './sementes-list';
import AdubosList from './adubos-list';
import { PropsGetRecomendacaoPrint } from '../../utils';
import Printable from '../../printable';

const Resumo: StepComponent = ({ formObject, safras }) => {
  const [dataHoraPrint, setDataHoraPrint] = useState(() => '');
  const [dataToPrint, setDataToPrint] = useState<PropsGetRecomendacaoPrint>({
    situacao: 'aberto',
    status: 'rascunho',
    adubos: [],
    sementeCobertura: false,
    comMargemSeguranca: false,
    talhoes: [],
  });

  const [
    adubos,
    sementeCobertura,
    comMargemSeguranca,
    distribuicaoRegulagemAdubo,
    porcentagemCorrecaoQuantidade,
    espacamento,
    talhoes,
    distribuicaoRegulagemSemente,
    porcentagemCorrecaoDensidade,
    porcentagemAreaRemonte,
    rendimentoOperacionalMaximo,
    rendimentoOperacionalMinimo,
    atividade,
    propriedade,
    safra,
    id,
    recomendante,
    situacao,
    status,
  ] = formObject.form.watch([
    'adubos',
    'sementeCobertura',
    'comMargemSeguranca',
    'distribuicaoRegulagemAdubo',
    'porcentagemCorrecaoQuantidade',
    'espacamento',
    'talhoes',
    'distribuicaoRegulagemSemente',
    'porcentagemCorrecaoDensidade',
    'porcentagemAreaRemonte',
    'rendimentoOperacionalMaximo',
    'rendimentoOperacionalMinimo',
    'atividade',
    'propriedade',
    'safra',
    'id',
    'recomendante',
    'situacao',
    'status',
  ]);

  const formValuesAdubo = useMemo(
    () => ({
      adubos,
      sementeCobertura,
      comMargemSeguranca,
      distribuicaoRegulagemAdubo,
      porcentagemAreaRemonte,
      espacamento,
    }),
    [
      adubos,
      sementeCobertura,
      comMargemSeguranca,
      distribuicaoRegulagemAdubo,
      porcentagemAreaRemonte,
      espacamento,
    ],
  );

  const formValuesSemente = useMemo(
    () => ({
      talhoes,
      distribuicaoRegulagemSemente,
      porcentagemCorrecaoDensidade,
      porcentagemAreaRemonte,
      rendimentoOperacionalMaximo,
      rendimentoOperacionalMinimo,
      atividade,
      espacamento,
      porcentagemCorrecaoQuantidade,
      sementeCobertura,
      comMargemSeguranca,
    }),
    [
      talhoes,
      distribuicaoRegulagemSemente,
      porcentagemCorrecaoDensidade,
      porcentagemAreaRemonte,
      rendimentoOperacionalMaximo,
      rendimentoOperacionalMinimo,
      atividade,
      espacamento,
      porcentagemCorrecaoQuantidade,
      sementeCobertura,
      comMargemSeguranca,
    ],
  );

  const printRef = useRef(null);
  const triggerPrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => setDataHoraPrint(''),
  });

  const onPressPrint = useImmutableCallback(() => {
    setDataHoraPrint(dayjs().format('DD/MM/YYYY HH:mm'));
    setDataToPrint({
      adubos,
      talhoes,
      comMargemSeguranca,
      sementeCobertura,
      atividade,
      distribuicaoRegulagemAdubo,
      distribuicaoRegulagemSemente,
      espacamento,
      porcentagemAreaRemonte,
      porcentagemCorrecaoDensidade,
      porcentagemCorrecaoQuantidade,
      rendimentoOperacionalMaximo,
      rendimentoOperacionalMinimo,
      propriedadeDescricao: propriedade?.descricao,
      safraId: String(safra?.id),
      safra: safras?.find((item) => item.id === safra?.id),
      id,
      situacao,
      status,
      recomendante,
      dataHoraImpressao: dayjs().format('DD/MM/YYYY HH:mm'),
    });
  });

  useEffect(() => {
    if (!dataHoraPrint) return;

    triggerPrint();
  }, [dataHoraPrint, triggerPrint]);

  return (
    <div className="recomendacoes-semeadura-create-edit-resumo">
      <div className="print-container">
        <Button
          icon="pi pi-print"
          className="print-button button-primary"
          onClick={onPressPrint}
        />
      </div>
      <SementesList formValues={formValuesSemente} />
      <AdubosList formValues={formValuesAdubo} />
      <Printable data={dataToPrint} ref={printRef} />
    </div>
  );
};

Resumo.validationSchema = Yup.object();

export default Resumo;
